// ============================================================
// types/notaActividad.types.ts
// ============================================================

// Niveles que usan nota por letra (AD/A/B/C) en lugar de nota numérica
export const NIVELES_NOTA_LETRA = ['INICIAL', 'PRIMARIA'] as const;
export type NivelNotaLetra = typeof NIVELES_NOTA_LETRA[number];

export const esNivelLetra = (nivel: string): boolean =>
  NIVELES_NOTA_LETRA.includes(nivel as NivelNotaLetra);

// Opciones de nota por letra para INICIAL y PRIMARIA (escala peruana)
export const NOTAS_LETRA = ['AD', 'A', 'B', 'C'] as const;
export type NotaLetra = typeof NOTAS_LETRA[number];

export const NOTA_LETRA_LABEL: Record<NotaLetra, string> = {
  AD: 'AD — Logro Destacado',
  A:  'A — Logro Esperado',
  B:  'B — En Proceso',
  C:  'C — En Inicio',
};

export const NOTA_LETRA_COLOR: Record<NotaLetra, string> = {
  AD: 'bg-blue-100 text-blue-700',
  A:  'bg-green-100 text-green-700',
  B:  'bg-amber-100 text-amber-700',
  C:  'bg-red-100 text-red-700',
};

// ── Payload individual (legacy, kept for reference) ─────────
export interface NotaActividadPayload {
  matriculaId:           number;
  asignacionAcademicaId: number;
  periodoId:             number;
  descripcion:           string;
  nota?:                 number;
  notaLetra?:            string;
  observacion:           string;
}

// ── Payload masivo → POST /notas-actividades/masivo ──────────
export interface NotaMasivoItem {
  matriculaId:  number;
  nota?:        number;
  notaLetra?:   string;
  observacion?: string;
}

export interface NotaActividadMasivoPayload {
  asignacionAcademicaId: number;
  periodoId:             number;
  descripcion:           string;
  notas:                 NotaMasivoItem[];
}

// ── Response del backend ─────────────────────────────────────
export interface NotaActividadResponse {
  idNotaActividad:       number;
  matriculaId:           number;
  estudianteNombres:     string;
  estudianteApellidos:   string;
  estudianteDni:         string;
  asignacionAcademicaId: number;
  cursoNombre:           string;
  periodoId:             number;
  periodoNombre:         string;
  descripcion:           string;
  nota:                  number | null;
  notaLetra:             string | null;
  observacion:           string;
  fechaRegistro:         string;
}

// ── Estado interno del formulario ────────────────────────────
export interface NotaActividadFormState {
  descripcion: string;
  nota:        string;
  notaLetra:   string;
  observacion: string;
}

export const NOTA_FORM_INITIAL: NotaActividadFormState = {
  descripcion: '',
  nota:        '',
  notaLetra:   'A',
  observacion: '',
};
